import React from 'react';
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import FalconComponentCard from 'components/common/FalconComponentCard';
import { Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import { nationalities } from '../../../config'
import { toast } from 'react-toastify';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import IconButton from 'components/common/IconButton';

import { useFormatDate } from 'hooks';
import { getColKeyArrayObject } from 'state/actions/users';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import Avatar from 'components/common/Avatar';
import { property } from 'underscore';


moment.locale("fr", {
  months:
    "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
      "_"
    ),
  monthsShort:
    "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm",
  },
  calendar: {
    sameDay: "[Aujourd’hui à] LT",
    nextDay: "[Demain à] LT",
    nextWeek: "dddd [à] LT",
    lastDay: "[Hier à] LT",
    lastWeek: "dddd [dernier à] LT",
    sameElse: "L",
  },
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans",
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function (number) {
    return number + (number === 1 ? "er" : "e");
  },
  meridiemParse: /PD|MD/,
  isPM: function (input) {
    return input.charAt(0) === "M";
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function (hours, minutes, isLower) {
    console.log(minutes, isLower);
    return hours < 12 ? "PD" : "MD";
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // Used to determine first week of the year.
  },
});





const CrmEdit = () => {
  registerLocale('fr', fr);
  setDefaultLocale('fr');
  const { id } = useParams();
  const [formd, setFrom] = React.useState({});
  const [l, setL] = React.useState(false);
  const [interlocuteurs, setInterlocuteur] = React.useState([]);

  const [is_moral, setMoral] = React.useState(false);
  const [is_owner, setIs_Owner] = React.useState(false);
  const [is_intendances, setIs_intendances] = React.useState(false);
  const [first_date, setFirstDate] = React.useState(new Date);
  const [valueLang, setValueLang] = React.useState(null);
  const [colexport, setColExport] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [valueBooking, setValueBooking] = React.useState(null);
  const [valueMailList, setValueMailList] = React.useState([]);
  const [validated, setValidated] = React.useState(false);
  const [reservations, setReservations] = React.useState([]);
  const [mailingsList, setMailingsList] = React.useState([]);
  const [villas, setVilla] = React.useState([]);
  const [valueIntendance, setValueIntendance] = React.useState([]);
  const [valueVilla, setValueVilla] = React.useState([]);
  const [preferences, setPreferences] = React.useState([]);


  const [picture_profile, setPictureProfile] = React.useState(null);
  const [files_id, setFileId] = React.useState([]);
  const [kbis, setKbis] = React.useState(null);
  const [rib, setRib] = React.useState(null);

  const options = {
    organicSearch: [
      { value: 'google', label: 'Google Organic' },
      { value: 'bing', label: 'Bing Organic' },
      { value: 'yahoo', label: 'Yahoo Organic' }
    ],
    paidSearch: [
      { value: 'googleAds', label: 'Google Ads' },
      { value: 'bingAds', label: 'Bing Ads' },
      { value: 'yahooAds', label: 'Yahoo Ads' }
    ],
    email: [
      { value: 'newsletter', label: 'Newsletter' },
      { value: 'outreach', label: 'Outreach' }
    ],
    sms: [
      { value: 'sms', label: 'SMS' },
      { value: 'whatsapp', label: 'WhatsApp' }
    ],
    organicSocial: [
      { value: 'instagram', label: 'Instagram' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'linkedin', label: 'LinkedIn' },
      { value: 'tiktok', label: 'TikTok' },
      { value: 'x', label: 'X' },
      { value: 'youtube', label: 'YouTube' },
      { value: 'pinterest', label: 'Pinterest' },
      { value: 'snapchat', label: 'Snapchat' }
    ],
    paidSocial: [
      { value: 'instagramAds', label: 'Instagram Ads' },
      { value: 'facebookAds', label: 'Facebook Ads' },
      { value: 'linkedinAds', label: 'LinkedIn Ads' },
      { value: 'tiktokAds', label: 'TikTok Ads' },
      { value: 'xAds', label: 'X Ads' },
      { value: 'youtubeAds', label: 'YouTube Ads' },
      { value: 'pinterestAds', label: 'Pinterest Ads' },
      { value: 'snapchatAds', label: 'Snapchat Ads' }
    ],
    referral: [{ value: 'website', label: '[Website name]' }],
    distribution: [
      { value: 'airbnb', label: 'Airbnb' },
      { value: 'booking', label: 'Booking.com' },
      { value: 'tripadvisor', label: 'Trip Advisor' }
    ],
    partnerAgent: interlocuteurs,
    influencer: [{ value: 'influencer', label: '[Influencer name]' }],
    offline: [
      { value: 'print', label: 'Print' },
      { value: 'tv', label: 'TV' },
      { value: 'radio', label: 'Radio' },
      { value: 'billboard', label: 'Billboard' },
      { value: 'screen', label: 'Screen' },
      { value: 'mail', label: 'Mail' },
      { value: 'wordOfMouth', label: 'Word of Mouth' },
      { value: 'event', label: 'Event' }
    ]
  };

  const loadUsers = () => {
    firebase.firestore().collection('users').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          if (l?.type === "admin") {
            const dr = { value: d.id, label: `${l?.lastName} ${l?.firstName}`, phone: l.phone, email: l.email, picture_profile: l.picture_profile }
            s.push(dr)
          }
        }

      })
      setInterlocuteur(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }


  const loadContracts = () => {

    firebase.firestore().collection('contracts')
      .orderBy("_update_At", "desc").get().then((snap) => {
        let s = [];
        snap.forEach((d) => {
          var l = d.data();
          l.id = d.id;
          l.clientName = l.client.label
          l.signdate = l.sign?.date ? l.sign?.date.toDate() : undefined
          if (l.delete) {

          } else {

            if (l.client.value === id) {
              s.push(l)
            }

          }
        })
        setData(s);
        console.log("contracts", s)
        setColExport(getColKeyArrayObject(s));
      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
  }


  const loadMailingsList = () => {
    firebase.firestore().collection('mailingslist').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.title}` }
          s.push(dr)
        }

      })
      setMailingsList(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  const loadVilla = () => {
    firebase.firestore().collection('properties').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.nameHouse}` }
          s.push(dr)
        }

      })
      setVilla(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }


  const loadBooking = () => {
    firebase.firestore().collection('bookings').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.origin?.label ? l?.origin?.label : "Inconnu"} - ${l?.property?.label ? l?.property?.label : "Inconnu"} - ${moment(l?.checkin?.toDate()).format('DD/MM/YYYY')}` }
          s.push(dr)
        }

      })
      setReservations(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }


  function removeDuplicates(array) {
    const uniqueValues = {};
    const result = [];

    array.forEach(item => {
      if (!uniqueValues[item.value]) {
        uniqueValues[item.value] = true;
        result.push(item);
      }
    });

    return result;
  }



  const NationalityField = ({ value, onChange }) => {


    return (
      <Form.Group as={Col} md="3" controlId="nationality">
        <Form.Label>Nationalité</Form.Label>

        <Form.Control
          as="select"
          name="nationality"
          value={value || ''}
          onChange={onChange}
        >
          <option value="">Sélectionnez une nationalité</option>
          {nationalities.map((nat, index) => (
            <option key={index} value={nat}>
              {nat}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Nationalité invalide.
        </Form.Control.Feedback>
      </Form.Group>
    );
  };


  const fmi = () => {
    loadUsers()
    loadVilla();
    loadBooking();
    loadMailingsList();
    loadContracts();
    setL(true);
    firebase.firestore().collection('crm').doc(id).get().then(doc => {
      if (doc) {
        let d = doc.data()
        d.id = doc.id;
        setIs_Owner(d.is_owner);
        setMoral(d.type === "moral")
        if (d?.property != undefined) {
          d.property = removeDuplicates(d?.property)
          setValueVilla(d.property)
        }
        setFrom(d)
        setValueBooking(d?.bookingList || d?.bookingList_update || [])
        setValueMailList(d?.mailingsList || d?.mailingsList_update || [])
        setValueIntendance(d?.intendancesPid || []);
        setPreferences(d?.preferences || []);
        setValueLang(d?.lang || { value: "fr", label: "Français" });
        // console.log("d", d);
        setL(false);
      } else {
        toast.error('Une erreur s\'est produite.');
      }
    }).catch((err) => {
      console.error("error", err);
      toast.error('Une erreur s\'est produite.');
      setL(false);
    })
  }


  React.useEffect(() => {
    if (id && !l) {
      fmi();
    }

  }, []);


  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  function generateString(length) {
    let result = '';
    const charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const sendFile = async (file, cb) => {
    const storage = firebase.storage();
    const metadata = {
      contentType: file.type,
    };

    const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
    const reference = storage.ref(ss);


    const uploadTask = reference.put(file, metadata);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (err) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (err.code) {
          case "storage/unauthorized":
            console.error("err", err)
            // User doesn't have permission to access the object
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
            );
            break;
          case "storage/canceled":
            // User canceled the upload alert(
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
            );
            break;

          // ...

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
            );
            break;
          default:
            break;
        }
      },
      () => {
        console.log("Image uploaded to the bucket!");



        uploadTask.snapshot.ref
          .getDownloadURL()
          .then(async (downloadURL) => {
            cb(downloadURL)
          });
      }
    );


  };

  const handleSubmit = (event) => {

    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    // alert("dev en cours")
    // console.log('form', formd);
    let d = { ...formd };
    d._updateAt = new Date();
    d.lang = valueLang;
    // d.birthday = formd?.birthday  || null;
    delete d._createAt;
    delete d?.files_id_update;
    delete d?.kbis_update;
    delete d?.rib_update;
    delete d?.picture_profile_update;

    setValidated(true);

    // console.log('i', d)
    setL(true);
    if (formd?.kbis_update) {
      sendFile(formd?.kbis_update, async (downloadURL) => {
        firebase.firestore().collection('crm').doc(id).update({ kbis_file: downloadURL })
        fmi();
      });
    }
    if (formd?.rib_update) {
      sendFile(formd?.rib_update, async (downloadURL) => {
        firebase.firestore().collection('crm').doc(id).update({ rib_file: downloadURL })
        fmi();
      });
    }
    if (formd?.picture_profile_update) {
      sendFile(formd?.picture_profile_update, async (downloadURL) => {
        firebase.firestore().collection('crm').doc(id).update({ picture_profile: downloadURL })
        fmi();
      });
    }
    if (formd?.files_id_update?.length > 0) {
      var ng = [];
      var index = 0;
      Array.from(formd?.files_id_update).forEach(async (n) => {
        sendFile(n, async (downloadURL) => {
          ng.push(downloadURL)
          index += 1;
          if (index === formd?.files_id_update.length) {
            firebase.firestore().collection('crm').doc(id).update({ files_id: ng })
            fmi();
          }
        });
      })
    }
    firebase.firestore().collection('crm').doc(id).update(d).then(() => {
      console.log("Document successfully written!");
      toast.success("Utilisateur modifié avec succès");
      // navigate('/users');  
      setL(false)
      setValidated(false);
      if (d.property?.length > 0) {
        // on va scanner les propriétés et ajouter l'identifiant a ownerId de la propriété 
        d.property?.forEach(p => {
          if (p.value) {
            firebase.firestore().collection('properties').doc(p.value).update({ ownerId: id, _update_At: new Date() })
          }
        });
      }
    }).catch(() => {
      setL(false)
      setValidated(false);
      toast.error("Erreur lors de la modification");

    })

  }

  const handleChange = e => {
    let d = { ...formd };
    // console.log(e.target.name, e.target?.checked, e.target?.value); 
    d[e.target.name] = e.target?.value;
    if (e.target.name === "is_owner") {
      d[e.target.name] = e.target.checked;
      setIs_Owner(e.target.checked);
    }


    if (e.target.name === "is_intendances") {
      d[e.target.name] = e.target.checked;
      setIs_intendances(e.target.checked);
    }

    if (e.target.name === "is_locataire") {
      d[e.target.name] = e.target.checked;
    }


    if (e.target.name === "type") {
      d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
      setMoral(e.target.value === "moral");
    }
    // console.log(d);
    setFrom(d);
  };

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('contracts').doc(id).update({ delete: true }).then((snap) => {
        toast.success("Le contrat à été supprimé");
        loadContracts()
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    }
  };

  const delItPI = async (index) => {
    let nf = [];
    formd?.files_id?.forEach((f, i) => {
      if (index !== i) {
        nf?.push(f);
      }
    })
    setL(true);
    try {
      firebase.firestore().collection('crm').doc(id).update({ files_id: nf }).then((snap) => {
        toast.success("Le fichier à été supprimé");

        let pre = { ...formd };
        pre.files_id = nf
        setFrom(pre)
        setL(false);
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    }
  }

  const del = (id) => {
    if (confirm(`Êtes vous certain de vouloir supprimer le contrat ?`)) {
      delIt(id);
    }
  }

  const delpi = (index) => {
    if (confirm(`Êtes vous certain de vouloir supprimer le fichier ?`)) {
      delItPI(index);
    }
  }

  const delkbis = () => {
    if (confirm(`Êtes vous certain de vouloir supprimer le fichier ?`)) {
      setL(true);
      firebase.firestore().collection('crm').doc(id).update({ kbis_file: null }).then(() => {
        toast.success("Le fichier à été supprimé");
        let pre = { ...formd };
        pre.kbis_file = null
        setFrom(pre)
        setL(false);
      })
    }
  }

  const delrib = () => {
    if (confirm(`Êtes vous certain de vouloir supprimer le fichier ?`)) {
      setL(true);
      firebase.firestore().collection('crm').doc(id).update({ rib_file: null }).then(() => {
        toast.success("Le fichier à été supprimé");
        let pre = { ...formd };
        pre.rib_file = null
        setFrom(pre)
        setL(false);
      })
    }
  }


  const columns = [
    {
      accessor: 'origin_id',
      Header: 'Numéro de demande interne',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'property',
      Header: 'Villa',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { property } = rowData.row.original
        return (<>{property && property?.label !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {property?.label}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'Date',
      Header: 'Date checkin - checkout',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { checkin, checkout } = rowData.row.original
        return (<>{checkin?.toDate !== undefined && checkout?.toDate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(checkin?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })} au {useFormatDate(checkout?.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'clientName',
      Header: 'Nom Prénom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'sign',
      Header: 'Signé',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { signdate, checkin } = rowData.row.original
        return (<>{signdate !== undefined && (
          <small className="has-text-grey is-abbr-like">
            {useFormatDate(signdate, {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'signbohouse',
      Header: 'Signé (bo-house)',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { sign } = rowData.row.original
        console.log("sign", rowData.row.original)
        return (<>{sign?.bohouse && sign?.bohouse_date && (
          <small className="has-text-grey is-abbr-like">

            {useFormatDate(sign?.bohouse_date.toDate(), {
              day: 'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short',
            })}
          </small>
        )}
        </>)
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { sign, signdate, id } = rowData.row.original
        return (<>
          {sign?.bohouse === null || sign?.bohouse === undefined && (
            <>
              <IconButton href={`/contract/${id}`}
                variant="falcon-default"
                size="sm"
                icon="sign"
                transform="shrink-3"
                className='me-2'
              >
                signé
              </IconButton>
            </>
          )}
          <IconButton href={`/contract/${id}`}
            variant="falcon-default"
            size="sm"
            icon="eye"
            transform="shrink-3"
            className='me-2'
          >
            <span className="d-none d-sm-inline-block ms-1"></span>
          </IconButton>

          {!(signdate !== undefined) && (
            <IconButton href={`#`} onClick={() => del(id)}
              variant="falcon-danger"
              size="sm"
              icon="trash"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1"></span>
            </IconButton>
          )}

        </>
        )
      }
    }
  ];

  function AdvanceTableExample() {

    return (
      <AdvanceTableWrapper
        columns={columns}
        data={data}
        sortable
        pagination
        perPage={205}
      >
        <AdvanceTable
          table
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        />
        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={data.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    );
  }


  return (
    <>
      {l ? (
        <p>Chargement ...</p>
      ) : (
        <FalconComponentCard>
          <FalconComponentCard.Header title={`Edition Client (${id})`} light={false} noPreview={true} />
          <FalconComponentCard.Body >
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Check
                  name="gender"
                  type="radio"
                  value="male"
                  onChange={handleChange}
                  label="Homme"
                  checked={formd.gender === "male" ? true : false}

                />
                <Form.Check
                  name="gender"
                  type="radio"
                  value="female"
                  onChange={handleChange}
                  label="Femme"
                  checked={formd.gender === "female" ? true : false}
                />
              </Form.Group>
              <Row className="mb-3">

                {formd?.picture_profile && (
                  <Form.Group controlId="formFile" className="mb-3" as={Col} md="1"  >
                    <Form.Label>Actuel</Form.Label>
                    <Avatar src={formd?.picture_profile} className="me-2" size="2xl" />
                  </Form.Group>
                )}
                <Form.Group controlId="formFile" className="mb-3" as={Col} md="8"  >
                  <Form.Label>Photo de profile</Form.Label>
                  <Form.Control type="file" name="picture_profile" accept="image/png, image/gif, image/jpeg"
                    onChange={(value) => {
                      setPictureProfile(value?.target?.files)
                      let d = { ...formd };
                      d.picture_profile_update = value?.target?.files[0]
                      setFrom(d);
                      console.log("picture_profile_update", d)

                    }} />
                </Form.Group>
                <Form.Group controlId="lang" className="mb-3" as={Col} md="3"  >
                  <Form.Label>Préférence langue</Form.Label>
                  <Select
                    // closeMenuOnSelect={false} 
                    options={[{ value: "fr", label: "Français" }, { value: "en", label: "Anglais" }]}
                    placeholder='Chosir la langue'
                    classNamePrefix="react-select"
                    value={valueLang}
                    onChange={value => {
                      setValueLang(value)
                      let d = formd;
                      d['lang'] = value;
                      setFrom(d);
                    }}
                  />
                </Form.Group>
              </Row>

              <Form.Group controlId="origin" className="mb-3" as={Col} md="6"  >
                <Form.Label>Origine</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name="origin"
                  minlength="3"
                  type="text"
                  placeholder="Origine"
                  value={formd.origin}
                />
              </Form.Group>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="exampleFirstName">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    onChange={handleChange}
                    name="firstName"
                    minlength="3"
                    type="text"
                    placeholder="Prénom"
                    value={formd.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    Veuillez indiquez votre Prénom.
                  </Form.Control.Feedback>
                  <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="exampleLastName">
                  <Form.Label>Nom de famille</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    onChange={handleChange}
                    placeholder="Nom de famille"
                    value={formd.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    Veuillez indiquez votre nom de famille.
                  </Form.Control.Feedback>
                  <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="exampleUserName">
                  <Form.Label>Email</Form.Label>
                  <InputGroup hasValidation>
                    <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Email"
                      aria-describedby="inputGroupPrepend"
                      onChange={handleChange}
                      value={formd.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      Veuillez indiquez l'email.
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="3" controlId="phone">
                  <Form.Label>Téléphone</Form.Label>
                  <Form.Control
                    name="phone"
                    value={formd.phone}
                    onChange={handleChange}
                    type="phone"
                    placeholder="Téléphone"
                    minlength="10" />
                  <Form.Control.Feedback type="invalid">
                    Téléphone invalide.
                  </Form.Control.Feedback>
                </Form.Group>

                <NationalityField value={formd?.nationality} onChange={(v) => {

                  let d = { ...formd };
                  d["nationality"] = v.target.value
                  setFrom(d)
                }} />
                {/* <Form.Group as={Col} md="3" controlId="nationality">
                <Form.Label>Nationalité</Form.Label>
                <Form.Control 
                  name="nationality"
                  onChange={handleChange} 
                  type="text" 
                  value={formd.nationality}
                  placeholder="Nationalité"   />
                <Form.Control.Feedback type="invalid">
                    Nationalité invalide.
                </Form.Control.Feedback>
                </Form.Group>  */}

                <Form.Group as={Col} md="3" controlId="birthday">
                  <Form.Label>Date de naissance</Form.Label>
                  <Form.Control
                    name="birthday"
                    type="date"
                    value={formd.birthday}
                    onChange={handleChange} placeholder="Date de naissance" />
                  <Form.Control.Feedback type="invalid">
                    Date de naissance invalide.
                  </Form.Control.Feedback>
                </Form.Group>


                <Form.Group as={Col} md="6" controlId="adresse">
                  <Form.Label>Adresse</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.adresse}
                    name="adresse"
                    onChange={handleChange}
                    placeholder="Adresse ..."
                  />
                </Form.Group>
                <Form.Group as={Col} md="3" controlId="city">
                  <Form.Label>Ville</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.city}
                    name="city"
                    onChange={handleChange}
                    placeholder="Ville ..."
                  />
                </Form.Group>

                <Form.Group as={Col} md="2" controlId="zipcode">
                  <Form.Label>Code postale</Form.Label>
                  <Form.Control
                    minlength="5"
                    type="text"
                    value={formd.zipcode}
                    name="zipcode"
                    onChange={handleChange}
                    placeholder="Code postale ..."
                  />
                </Form.Group>

                <Form.Group as={Col} md="2" controlId="country">
                  <Form.Label>Pays</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.country}
                    name="country"
                    onChange={handleChange}
                    placeholder="Pays ..."
                  />
                </Form.Group>

                <Form.Group as={Col} md="10" controlId="complement">
                  <Form.Label>Complément d'adresse</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.complement}
                    name="complement"
                    onChange={handleChange}
                    placeholder="Complément d'adresse ..."
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="5" >
                  <Form.Label>Pièce d'identité (recto & verso)</Form.Label>
                  <Form.Control type="file" multiple name="files_id" accept="image/png, image/gif, image/jpeg, application/pdf"
                    onChange={(value) => {
                      setFileId(value?.target?.files)
                      let d = { ...formd };
                      d.files_id_update = value?.target?.files
                      setFrom(d);
                      console.log("files_id_update", d)
                    }}
                  />
                </Form.Group>
                {
                  formd?.files_id && (
                    <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="5" >
                      {
                        formd?.files_id?.map((f, i) => {
                          return <p>
                            <a href={f} target="_blank">Voir le fichier</a> <IconButton onClick={() => { delpi(i); }} variant="falcon-danger" size="sm" icon="trash" transform="shrink-3" className='me-2' >
                              <span className="d-none d-sm-inline-block ms-1"></span>
                            </IconButton>
                          </p>
                        })
                      }
                    </Form.Group>
                  )
                }
              </Row>

              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  name="is_owner"
                  onChange={handleChange}
                  label="C'est un propriétaire"
                  checked={formd.is_owner}
                />
              </Form.Group>
              {formd.is_owner && (
                <Row className="mb-3">
                  <Form.Group as={Col} md="6" controlId="selectVilla">
                    <Form.Label>Chosir les biens du propriétaire (si ce n'est pas une société)</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={villas}
                      isMulti
                      placeholder='Chosir les biens du propriétaire...'
                      classNamePrefix="react-select"
                      value={valueVilla}
                      onChange={value => {
                        setValueVilla(value)
                        let d = formd;
                        d['property'] = value;
                        setFrom(d);

                      }}
                    />
                  </Form.Group>
                </Row>

              )}

              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  name="is_locataire"
                  onChange={handleChange}
                  label="C'est un locataire"
                  checked={formd.is_locataire}
                />
                {/* <p>{formd.is_owner}</p> */}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  name="is_intendances"
                  onChange={handleChange}
                  label="C'est une intendant"
                  checked={formd.is_intendances}
                />
                {/* <p>{formd.is_owner}</p> */}
              </Form.Group>
              {formd.is_intendances && (
                <Row className="mb-3">
                  <Form.Group as={Col} md="4" controlId="intendancerole">
                    <Form.Label>Rôle d'intendant</Form.Label>
                    <Form.Control
                      type="text"
                      name="intendance"
                      onChange={handleChange}
                      placeholder="Jardinier, Cuisinier, consierge, ..."
                      value={formd.intendance}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="6" controlId="intendancesPid">
                    <Form.Label>Chosir les biens lié à l'intendances</Form.Label>

                    <Select
                      closeMenuOnSelect={false}
                      options={villas}
                      isMulti
                      placeholder="Chosir les biens de l'intendances..."
                      classNamePrefix="react-select"
                      value={valueIntendance}
                      onChange={value => {
                        setValueIntendance(value)
                        let d = formd;
                        d['intendancesPid'] = value;
                        setFrom(d);

                      }}
                    />
                  </Form.Group>
                </Row>

              )}

              <Row className="mb-3">
                <Form.Group className="mb-3">
                  <p>Type de compte</p>
                  <Form.Check
                    name="type"
                    type="radio"
                    value="physique"
                    checked={!is_moral}
                    onChange={handleChange}
                    label="Personne physique"
                  />
                  <Form.Check
                    name="type"
                    type="radio"
                    value="moral"
                    checked={is_moral}
                    onChange={handleChange}
                    label="Personne morale"
                  /></Form.Group>
              </Row>
              {is_moral && formd.businessName && (<>
                <Row className="mb-3" style={{backgroundColor:'grey', padding: 20}}>
                <p>‼️ CE BLOC N'EST PLUS UTILISÉ, veuillez associer les propriétés du propriétaire en créant une société directement avec le nouveau bouton juste dessous</p>
                <p>Nom de la société : {formd.businessName}<br/>Adresse: {formd.businessAdresse} {formd.businessCity} {formd.businessZipcode} {formd.businessCountry}</p> 
                 {formd.siren &&  <p>Siren: {formd.siren}</p>}
                  {formd?.kbis_file != null
                    && (
                         <p>KBIS: <a href={formd?.kbis_file} target="_blank">Voir le fichier</a> <IconButton onClick={() => { delkbis(); }} variant="falcon-danger" size="sm" icon="trash" transform="shrink-3" className='me-2' >
                            <span className="d-none d-sm-inline-block ms-1"></span>
                          </IconButton>
                        </p> 
                    )
                  }
                </Row> 
              </>
              )}

              {is_moral && (<>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <Form.Label>Sociétés</Form.Label>
                      <Button
                        variant="falcon-default"
                        size="sm"
                        onClick={() => {
                          let d = { ...formd };
                          if (!d.companies) d.companies = [];
                          d.companies.push({
                            businessName: '',
                            representBy: '',
                            businessAdresse: '',
                            businessCity: '',
                            businessZipcode: '',
                            businessCountry: '',
                            siren: '',
                            kbis_file: null,
                            property: [],
                          });
                          setFrom(d);
                        }}
                      >
                        <FontAwesomeIcon icon="plus" className="me-1" /> Ajouter une société
                      </Button>
                    </div>
                  </Form.Group>

                  {formd.companies?.map((company, index) => (
                    <div key={index} className="border rounded p-3 mb-3 position-relative">
                      <IconButton
                        className="position-absolute"
                        style={{ top: '10px', right: '10px' }}
                        variant="falcon-danger"
                        size="sm"
                        icon="trash"
                        onClick={() => {
                          let d = { ...formd };
                          d.companies.splice(index, 1);
                          setFrom(d);
                        }}
                      />
                      
                      <Row>
                        <Form.Group as={Col} md="4" className="mb-3">
                          <Form.Label>Nom de la société</Form.Label>
                          <Form.Control
                            minLength="3"
                            type="text"
                            value={company.businessName}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].businessName = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Nom de la société"
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4" className="mb-3">
                          <Form.Label>Représentant</Form.Label>
                          <Form.Control
                            minLength="3"
                            type="text"
                            value={company.representBy}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].representBy = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Représenté par"
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="6" className="mb-3">
                          <Form.Label>Adresse</Form.Label>
                          <Form.Control
                            type="text"
                            value={company.businessAdresse}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].businessAdresse = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Adresse ..."
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="3" className="mb-3">
                          <Form.Label>Ville</Form.Label>
                          <Form.Control
                            type="text"
                            value={company.businessCity}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].businessCity = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Ville ..."
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="2" className="mb-3">
                          <Form.Label>Code postal</Form.Label>
                          <Form.Control
                            minLength="5"
                            type="text"
                            value={company.businessZipcode}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].businessZipcode = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Code postal ..."
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="2" className="mb-3">
                          <Form.Label>Pays</Form.Label>
                          <Form.Control
                            type="text"
                            value={company.businessCountry}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].businessCountry = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Pays ..."
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4" className="mb-3">
                          <Form.Label>Numéro de SIREN</Form.Label>
                          <Form.Control
                            minLength="3"
                            type="text"
                            value={company.siren}
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].siren = e.target.value;
                              setFrom(d);
                            }}
                            placeholder="Numéro de SIREN"
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="5" className="mb-3">
                          <Form.Label>KBIS ou avis SIREN</Form.Label>
                          <Form.Control
                            type="file"
                            onChange={(e) => {
                              let d = { ...formd };
                              d.companies[index].kbis_update = e.target.files[0];
                              setFrom(d);
                            }}
                          />
                        </Form.Group>

                        {company.kbis_file && (
                          <Form.Group as={Col} md="3" className="mb-3">
                            <Form.Label>Actuel</Form.Label>
                            <p>
                              <a href={company.kbis_file} target="_blank">Voir le fichier</a>
                              <IconButton
                                onClick={() => {
                                  let d = { ...formd };
                                  d.companies[index].kbis_file = null;
                                  setFrom(d);
                                }}
                                variant="falcon-danger"
                                size="sm"
                                icon="trash"
                                className="ms-2"
                              />
                            </p>
                          </Form.Group>
                        )}
                      </Row>
                      <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="selectVilla">
                          <Form.Label>Choisir les biens de la société</Form.Label>
                          <Select
                            closeMenuOnSelect={false}
                            options={villas}
                            isMulti
                            placeholder='Choisir les biens de la société...'
                            classNamePrefix="react-select"
                            value={company.property}
                            onChange={value => {
                              // setValueVilla(value)
                              // let d = formd;
                              // d['property'] = value;
                              // setFrom(d);
                              let d = { ...formd };
                                  d.companies[index].property = value;
                                  setFrom(d);
                            }}
                          />
                        </Form.Group>
                      </Row>
                    </div>
                  ))}
                </Row>
              </>)}

              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="iban">
                  <Form.Label>Numéro de compte (IBAN)</Form.Label>
                  <Form.Control
                    minlength="3"
                    type="text"
                    name="iban"
                    onChange={handleChange}
                    value={formd.iban}
                    placeholder="Numéro de compte (IBAN)"
                  />
                </Form.Group>

                <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="5"  >
                  <Form.Label>IBAN (fichier)</Form.Label>
                  <Form.Control type="file" name="RIB_file"
                    onChange={(value) => {
                      setRib(value?.target?.files)
                      let d = { ...formd };
                      d.rib_update = value?.target?.files[0]
                      setFrom(d);
                      console.log("rib_update", d)
                    }} />
                </Form.Group>

                {formd?.rib_file != null && (
                  <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="3"  >
                    <Form.Label>Actuel</Form.Label>
                    <p>
                      <a href={formd?.rib_file} target="_blank">Voir le fichier</a> <IconButton onClick={delrib} variant="falcon-danger" size="sm" icon="trash" transform="shrink-3" className='me-2' >
                        <span className="d-none d-sm-inline-block ms-1"></span>
                      </IconButton>
                    </p>
                  </Form.Group>
                )}


              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="7" controlId="bookingorder">
                  <Form.Label>Assigné les réservations précédente</Form.Label>
                  <Select
                    autocomplete="off"
                    closeMenuOnSelect={false}
                    options={reservations}
                    placeholder='Choisir...'
                    isMulti
                    classNamePrefix="react-select"
                    value={valueBooking}
                    onChange={value => {
                      setValueBooking(value)
                      let d = { ...formd };
                      d.bookingList = value
                      setFrom(d);
                      console.log("bookingList_update", d)

                    }}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="emailingList">
                  <Form.Label>Liste d'emailing</Form.Label>

                  <Select
                    autocomplete="off"
                    closeMenuOnSelect={false}
                    options={mailingsList}
                    placeholder='Choisir...'
                    isMulti
                    classNamePrefix="react-select"
                    value={valueMailList}
                    onChange={value => {
                      setValueMailList(value)
                      let d = { ...formd };
                      d.mailingsList = value
                      setFrom(d);
                      console.log("mailingsList_update", d)
                    }}
                  />

                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Label>Préférences</Form.Label>
                {
                  preferences.map((pref, index) => {
                    return (<Row className="mb-3">
                      <Form.Group as={Col} md="10" className="mb-3">
                        <Form.Control
                          name={`pref_${index}`}
                          placeholder="Préférence"
                          value={pref}
                          onChange={(e) => {
                            let o = [...preferences];
                            o[index] = e.target.value;
                            setPreferences(o);
                            let d = { ...formd };
                            d['preferences'] = o;
                            setFrom(d);
                          }}
                        />
                      </Form.Group>

                      <IconButton as={Col} md="1" onClick={() => {
                        let arr = preferences;
                        arr.splice(index, 1);
                        setPreferences(arr);
                        let d = { ...formd };
                        d['preferences'] = arr;
                        setFrom(d);
                      }}
                        variant="falcon-danger"
                        size="sm"
                        icon="trash"
                        transform="shrink-3"
                        className='me-2'
                        style={{ width: 60, height: 25 }}
                      >
                      </IconButton>
                    </Row>)
                  })
                }

                <div>
                  <Flex
                    alignItems="center"
                    className="mb-4 text-primary cursor-pointer fs-0"
                    onClick={() => {
                      let o = [...preferences];
                      if (o[o.length - 1]?.trim() !== "") {
                        o.push("");
                        setPreferences(o);
                      }
                    }}
                  >
                    <span className="circle-dashed">
                      <FontAwesomeIcon icon="plus" />
                    </span>
                    <span className="ms-3">Ajouter une nouvelle préférence</span>
                  </Flex>
                </div>




              </Row>


              <hr className="mt-3" />


              <Form.Group as={Col} md="3" controlId={`booked_date`}>
                <Form.Label>Date du premier contact </Form.Label>
                <Form.Control
                  name="first_date"
                  type="date"
                  onChange={handleChange} placeholder="du premier contact" />

                {/* <DatePicker
                    selected={first_date} 
                    dateFormat="dd/MM/yyyy"
                    onChange={newDate => {
                        let d = formd;
                        d['first_date'] = newDate;
                        setFrom(d)
                        setFirstDate(newDate) 
                    }}
                    customInput={
                        <CustomDateInput
                        formControlProps={{
                            placeholder: 'jj/mm/yy',
                        //     ...register(`ScheduleStartDate${index}`)
                        }}
                        />
                    }
                    /> */}
              </Form.Group>

              {/* parain */}
              <hr />
              <Row>
                <h5>
                  Information sur le parrain
                </h5>

                <Row className="mb-3">
                  <Form.Group as={Col} md="4" controlId="exampleFirstNameparrain">
                    <Form.Label>Prénom</Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      name="firstNameparain"
                      type="text"
                      placeholder="Prénom du parrain"
                      value={formd.firstNameparain}
                    />
                    <Form.Control.Feedback type="invalid">
                      Veuillez indiquez votre Prénom.
                    </Form.Control.Feedback>
                    <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4" controlId="exampleLastNameparrain">
                    <Form.Label>Nom de famille</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastNameparrain"
                      onChange={handleChange}
                      value={formd.lastNameparrain}
                      placeholder="Nom de famille du parrain"
                    />
                    <Form.Control.Feedback type="invalid">
                      Veuillez indiquez votre nom de famille.
                    </Form.Control.Feedback>
                    <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4" controlId="exampleUserName">
                    <Form.Label>Email</Form.Label>
                    <InputGroup hasValidation>
                      <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                      <Form.Control
                        type="email"
                        name="emailparrain"
                        placeholder="Email"
                        aria-describedby="inputGroupPrepend"
                        value={formd.emailparrain}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Veuillez indiquez l'email.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="3" controlId="phone">
                    <Form.Label>Téléphone</Form.Label>
                    <Form.Control
                      name="phoneparrain"
                      value={formd.phoneparrain}
                      onChange={handleChange} type="phone" placeholder="Téléphone" />
                    <Form.Control.Feedback type="invalid">
                      Téléphone invalide.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="origin" className="mb-3" as={Col} md="6"  >
                    <Form.Label>Origine</Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={formd.originparrain}
                      name="originparrain"
                      type="text"
                      placeholder="Origine"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="parraindate">
                    <Form.Label>Date de mise en relation</Form.Label>
                    <Form.Control
                      name="parraindate"
                      value={formd.parraindate}
                      type="date"
                      onChange={handleChange} placeholder="Date de mise en relation" />
                    <Form.Control.Feedback type="invalid">
                      Date de mise en relation invalide.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </Row>
              <hr />
              <Row className="mb-3">
                <Form.Label>Commentaire</Form.Label>
                <Form.Group className="mb-3">

                  <Form.Control as="textarea" name="comment"
                    value={formd.comment}
                    onChange={handleChange}
                    placeholder="Laisser un commentaire ici"
                    style={{ height: '100px' }}
                  />
                </Form.Group>

              </Row>

              <Row className="mb-3">
                <h5>
                  Channels, Sources & Contact Methods
                </h5>
                {Object.keys(options).map(field => (
                  <Form.Group controlId={field} className="mb-3" as={Col} md="3" key={field}>

                    <Form.Label>{field.replace(/([A-Z])/g, ' $1').toUpperCase()}</Form.Label>
                    {field === "influencer" ||field ===  "referral" ? (
                      <Form.Control
                        onChange={handleChange}
                        value={formd[field]}
                        name={field}
                        type="text"
                        placeholder={field}
                      />
                    ) : (
                      <Select
                        placeholder={`Chosir ${field.replace(/([A-Z])/g, ' $1').toUpperCase()}`}
                        classNamePrefix="react-select"
                        options={options[field]}
                        value={formd[field]}
                        onChange={value => {
                          let d = formd;
                          d[field] = value;
                          setFrom(d);

                        }}
                      />
                    )}

                  </Form.Group>
                ))}
              </Row>


              <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>
            </Form>
          </FalconComponentCard.Body>
        </FalconComponentCard>
      )}
      <FalconComponentCard>
        <FalconComponentCard.Header
          title="Contrats"
          light={false}
          className="border-bottom border-200" noPreview={true}
        />
        <FalconComponentCard.Body>
          <AdvanceTableExample />
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

export default CrmEdit;
